import { Inject } from "@angular/core";
import { ContentControlledEditingDirective } from '../editing-directive';
import { ContentControlledKeyframe } from '../keyframe';
import ContentControlStudioOperation from "./content-control-studio-operation";

export default class ContentControlStudioRemoveKeyframeToEventOperation extends ContentControlStudioOperation {
  constructor(
    public event: ContentControlledEditingDirective,
    public keyframe: ContentControlledKeyframe,
    callback?,
  ) {
    super(
      () => {
        if (event) {
          const index = event.keyframes.findIndex((x) => x.sameTime(keyframe));
          if (index > -1) {
            event.keyframes.splice(index, 1);
          }
        }
      },
      () => {
        if (event) {
          if (event.keyframes.findIndex((x) => x.sameTime(keyframe)) == -1) {
            event.keyframes.push(keyframe);
            event.sortKeyframes();
          }
        }
      },
      callback,
    );
  }
}
